import React, { useEffect } from "react";
import "./App.css";
import SignIn from "../login/SignIn";

import ClippedDrawer from "../common/ClippedDrawer";
import AppTopBar from "../common/AppTopBar";
import { useState } from "react";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { useMediaQuery } from "@mui/material";
import GlobalMessage from "../common/GlobalMessageHandling";
import ConfigData from "../config/config.json";
import { Routes, Route } from "react-router-dom";
import ForgotPassword from "../login/ForgotPassword";
//import Schedule from 'react-schedule-job';

export const ColorModeContext = React.createContext({
  toggleColorMode: () => {},
});

export const UserContext = React.createContext({
  user: { name: "", authenticated: false, role: "" },
  setUser: () => {},
});

export const GlobalMessageContext = React.createContext({
  globalMessage: "",
  severity: "",
  setGlobalMessage: () => {},
});

const webserver = ConfigData.WEBSERVER;

function App() {
  const [user, setUser] = useState({
    name: "",
    authenticated: false,
    role: "",
  });
  const [globalMessage, setGlobalMessage] = useState({
    globalMessage: "",
    severity: "",
  });

  useEffect(() => {
    fetch(
      webserver.protocol +
        "://" +
        webserver.host +
        ":" +
        webserver.port +
        "/user/getRole",
      { method: "GET", credentials: "include" }
    )
      .then((response) => {
        if (response.status !== 200) {
          throw new Error("Unauthorized");
        }
        return response;
      })
      .then((response) => response.json())
      .then((data) => {
        setUser((prevState) => {
          return { name: data.userName, authenticated: true, role: data.role };
        });
      })
      .catch((error) => {
        setUser({ name: "", authenticated: false, role: "" });
      });
  }, []);

  return (
    <>
      <UserContext.Provider value={{ user, setUser }}>
        <GlobalMessageContext.Provider
          value={{
            globalMessage: globalMessage,
            setGlobalMessage: setGlobalMessage,
          }}
        >
          {user.authenticated ? (
            //Routing for authenticated user
            /*<Router>
            <Routes>
              <Route path="/" element={<App />} />
              <Route path="/login" element={<SignIn />} />
              <Route path="/d" element={<Dashboard />} />
              <Route path="/c" element={<ClippedDrawer />} />
            </Routes>
          </Router>*/
            <ClippedDrawer />
          ) : (
            <SignIn />
          )}
          <GlobalMessage />
        </GlobalMessageContext.Provider>
      </UserContext.Provider>
    </>
  );
}

export function ToggleColorMode() {
  const prefersDarkMode = useMediaQuery("(prefers-color-scheme: dark)");
  const preferredMode = prefersDarkMode ? "dark" : "light";

  const [mode, setMode] = React.useState(preferredMode);
  const colorMode = React.useMemo(
    () => ({
      toggleColorMode: () => {
        setMode((prevMode) => (prevMode === "light" ? "dark" : "light"));
      },
    }),
    []
  );

  const theme = React.useMemo(
    () =>
      createTheme({
        palette: {
          mode,
        },
      }),
    [mode]
  );

  return (
    <ColorModeContext.Provider value={colorMode}>
      <AppTopBar theme={theme} />
      <ThemeProvider theme={theme}>
        <Routes>
          <Route path="/" element={<App />} />
          <Route path="/login" element={<SignIn />} />
          <Route path="/password.html" element={<ForgotPassword />} />
        </Routes>
      </ThemeProvider>
    </ColorModeContext.Provider>
  );
}

export default App;
